export const SendIcon = props => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_5875_20469"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="21"
    >
      <rect x="0.5" y="0.5" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_5875_20469)">
      <path
        d="M5.99417 16.5C5.58139 16.5 5.22917 16.3531 4.9375 16.0594C4.64583 15.7656 4.5 15.4125 4.5 15V14.25C4.5 14.0375 4.57146 13.8594 4.71437 13.7156C4.85729 13.5719 5.03437 13.5 5.24562 13.5C5.45687 13.5 5.63542 13.5719 5.78125 13.7156C5.92708 13.8594 6 14.0375 6 14.25V15H15V14.25C15 14.0375 15.0715 13.8594 15.2144 13.7156C15.3573 13.5719 15.5344 13.5 15.7456 13.5C15.9569 13.5 16.1354 13.5719 16.2812 13.7156C16.4271 13.8594 16.5 14.0375 16.5 14.25V15C16.5 15.4125 16.3531 15.7656 16.0592 16.0594C15.7653 16.3531 15.4119 16.5 14.9992 16.5H5.99417ZM9.75 6.375L8.08333 8.04167C7.93056 8.19444 7.75347 8.27083 7.55208 8.27083C7.35069 8.27083 7.17028 8.19444 7.01083 8.04167C6.86472 7.88889 6.79167 7.71181 6.79167 7.51042C6.79167 7.30903 6.86806 7.13194 7.02083 6.97917L9.97917 4.02083C10.0542 3.95139 10.1354 3.89931 10.2229 3.86458C10.3104 3.82986 10.4042 3.8125 10.5042 3.8125C10.6042 3.8125 10.6979 3.82986 10.7854 3.86458C10.8729 3.89931 10.9514 3.95139 11.0208 4.02083L13.9792 6.97917C14.1319 7.13194 14.2083 7.30556 14.2083 7.5C14.2083 7.69444 14.1353 7.86806 13.9892 8.02083C13.8297 8.17361 13.6493 8.25 13.4479 8.25C13.2465 8.25 13.0694 8.17361 12.9167 8.02083L11.25 6.375V12.75C11.25 12.9625 11.1785 13.1406 11.0356 13.2844C10.8927 13.4281 10.7156 13.5 10.5044 13.5C10.2931 13.5 10.1146 13.4281 9.96875 13.2844C9.82292 13.1406 9.75 12.9625 9.75 12.75V6.375Z"
        fill="#5663F2"
      />
    </g>
  </svg>
);
